import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconComponent } from '../../../../icon/icon.component';
import { PillComponent } from '../../../../pill/pill.component';
import { AddAttributesDirective } from '../../../bar/directives/add-attributes/add-attributes.directive';
import { Navigation } from '../../../bar/models/bar.type';

@Component({
    selector: 'nw-side-menu-parent',
    templateUrl: './side-menu-parent.component.html',
    styleUrls: ['./side-menu-parent.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconComponent, PillComponent, AddAttributesDirective]
})
export class SideMenuParentComponent {
    @Input() label!: string;
    @Input() badge?: Navigation.Badge;
    @Input() active: boolean = false;
    @Input() open: boolean = false;
    @Input() parentId?: number;
}
